import { render } from "./QHLSPendingApprovalList.vue?vue&type=template&id=3f10b9a6"
import script from "./QHLSPendingApprovalList.vue?vue&type=script&lang=js"
export * from "./QHLSPendingApprovalList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__